import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import React from 'react';
import { ListItem, DropdownItemStyle, DropdownItemAnchorStyle, DropdownItemNavLinkStyle } from './DropdownItem.styles.js';
export { ListItem } from './DropdownItem.styles.js';

const DropdownItem = React.forwardRef(function DropdownItem(_a, ref) {
    var { unmountAfterClick } = _a, props = __rest(_a, ["unmountAfterClick"]);
    return (jsx(ListItem, Object.assign({ ref: ref }, { children: jsx(DropdownItemStyle, Object.assign({ tabIndex: 0, type: "button", "data-unmountafterclick": unmountAfterClick }, props, { children: props.children })) })));
});
const DropdownItemAnchor = (props) => (jsx(ListItem, { children: jsx(DropdownItemAnchorStyle, Object.assign({}, props, { children: props.children })) }));
const DropdownItemNavLink = (props) => {
    return (jsx(ListItem, { children: jsx(DropdownItemNavLinkStyle, Object.assign({}, props, { children: props.children })) }));
};

export { DropdownItem, DropdownItemAnchor, DropdownItemNavLink };
